module.exports = __webpack_public_path__ + "static/jumanji-carousel-8ecc164f3554ce8507e31606e0cbc135.jpg";